import { render, staticRenderFns } from "./TaxPositionCard.vue?vue&type=template&id=2faed759&scoped=true&"
import script from "./TaxPositionCard.vue?vue&type=script&lang=js&"
export * from "./TaxPositionCard.vue?vue&type=script&lang=js&"
import style0 from "./TaxPositionCard.vue?vue&type=style&index=0&id=2faed759&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faed759",
  null
  
)

export default component.exports